import { DetalleCarrito } from "./detalle-carrito";

export class Tercero {

  celular: string;
  direccion: string;
  email: string;
  estado: string;
  fechaCreacion: Date;
  fechaModificacion: Date;
  numeroIdentificacion: string;
  primerApellido: string;
  primerNombre: string;
  razonSocial: string;
  segundoApellido: string;
  segundoNombre: string;
  sexo: string;
  tercId: number;
  usuarioCreador: string;
  usuarioModificador: string;
  tiidId_SicaTipoIdentificacion: number;
  titeId_SicaTipoTercero: number;
  codigoActivacion: string;
  password: string;
  nombreCompleto: string;
  rol: string;
  detallesCarrito: DetalleCarrito[];
  nuevoEmail: string;

  constructor() {}

}
